import Assign from './Assign/Assign';
import Add from "./Add/Add";
import Delete from "./Delete/Delete";
import { types } from './types';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(action, showAlert, variables, setOpenVariable) {
    // control of action name then return component
    switch (action.actionName){
        case types.ASSIGN: return <Assign action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.ADD: return <Add action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.DELETE: return <Delete action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        default: break;
    }
}

export default Actions;
